import {EnvironmentType,} from '@models/system-vo/environment-type';
import {LogLevel,} from '@models/index';

// OFI AWS Production(本番)環境のConfig
export const environment = {
  production: true,
  type: EnvironmentType.PROD,
  log_level: LogLevel.INFO,
  output_method_log: false,
  server_host: 'https://prod-lb.ivar-ofi.jp:8080',
  ignore_client_validation_for_testing: false,
  endpoint: {
    api: '/sms/api',
  },
};
